import React from "react";

import DestinationAddressCellContent from "../components/DestinationAddressCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function destinationAddress({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.DestinationAddress,
		(item) => (
			<DestinationAddressCellContent item={item} language={language} />
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default destinationAddress;
